import { Logger } from "@wemade-vsf/core";
const attachToCartCommand = {
  execute: async (context, params) => {
    var _a, _b, _c;
    Logger.debug("[Magento]: Attach guest cart to user");
    const emailOnCartInput = {
      email: params == null ? void 0 : params.email,
      cart_id: (_b = (_a = params == null ? void 0 : params.cart) == null ? void 0 : _a.value) == null ? void 0 : _b.id
    };
    await context.app.$vsf.$magento.api.setGuestEmailOnCart({
      ...emailOnCartInput
    }, (_c = params == null ? void 0 : params.customQuery) != null ? _c : null, params == null ? void 0 : params.customHeaders);
  }
};
export {
  attachToCartCommand
};
